/**
 * The till's warning about a blocked phone or e-mail - `FRONTEND.md` §9.787, on BACKEND.md §10A.439, owner O140.
 *
 * A staff order is not refused - the person on the phone decides - but they should know. Asked only once the typed
 * value could match: six digits (the server's own floor for a phone key, `BlockedContactKeys.MIN_PHONE_DIGITS`) or an
 * address with something after its `@`, so the till does not ask about every keystroke of a number.
 */

export const MATCH_PHONE_DIGITS = 6

/** What to ask about, or null while nothing typed could match a block. */
export function blockLookupOf(phone: string, email: string): { phone: string; email: string } | null {
  const digits = phone.replace(/\D/g, '')
  const phoneReady = digits.length >= MATCH_PHONE_DIGITS
  const atSign = email.indexOf('@')
  const emailReady = atSign > 0 && atSign < email.trim().length - 1
  if (!phoneReady && !emailReady) return null
  return { phone: phoneReady ? phone : '', email: emailReady ? email : '' }
}
